var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,2.5a5.47,5.47,0,0,1,3.89,1.61A5.47,5.47,0,0,1,13.5,8a5.47,5.47,0,0,1-1.61,3.89A5.47,5.47,0,0,1,8,13.5a5.47,5.47,0,0,1-3.89-1.61A5.47,5.47,0,0,1,2.5,8,5.47,5.47,0,0,1,4.11,4.11,5.47,5.47,0,0,1,8,2.5M8,1a7,7,0,1,0,7,7A7,7,0,0,0,8,1Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "none"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 7.25,
    width: 7,
    height: 1.5,
    rx: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon_remove.fa9645cc339b5300a28272d03d6a4c3c.svg";
export { ForwardRef as ReactComponent };